(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/player-service/assets/javascripts/utils/normalize.js') >= 0) return;  svs.modules.push('/components/racing/player-service/assets/javascripts/utils/normalize.js');

'use strict';

const parseISO = dateFns.parseISO;
const format = dateFns.format;
function normalizeWagers(resp) {
  return resp && resp.wagers && resp.wagers.map(wager => ({
    betAmount: wager.betAmount,
    completed: wager.completed,
    completedOn: wager.completedOn ? format(parseISO(wager.completedOn), 'd/M, HH:mm') : null,
    description: wager.description,
    examined: wager.examined,
    lastDrawDate: wager.lastDrawDate ? format(parseISO(wager.lastDrawDate), 'd/M, HH:mm') : null,
    regWagerTime: wager.regWagerTime ? format(parseISO(wager.regWagerTime), 'd/M, HH:mm') : null,
    subproductName: wager.subproductName,
    winAmount: wager.winAmount,
    wagerId: wager.wagerId,
    refunds: wager.refunds ? wager.refunds.map(refund => ({
      amount: refund.amount
    })) : null,
    pagingSortKey: wager.pagingSortKey,
    time: wager.properties && wager.properties.time ? format(parseISO(wager.properties.time), 'd/M, HH:mm') : null,
    groupId: wager.properties && wager.properties.groupId
  }));
}
if (svs.isServer) {
  module.exports = {
    normalizeWagers
  };
} else {
  svs.racing.playerService.utils.normalize = {
    normalizeWagers
  };
}

 })(window);